import Model from './BaseModel'

export default class Profile extends Model {
    resourceName() {
        return 'profile'
    }

    fields() {
        return ['name', 'email', 'password', 'password_confirmation']
    }
}
